export const STATUS = {
  allPictures: 'allPictures',
  isValid: 'isValid',
  isInValid: 'isInValid',
  isClockedIn: 'isClockedIn',
  isClockedOut: 'isClockedOut',
}
